import { RouteConfig } from 'vue-router'
import { Role } from '@/models/role'

import workbenchIcon from '@/assets/images/icon_menu_workbench@2x.png'
import workbenchIconActive from '@/assets/images/icon_menu_workbench_active@2x.png'

import homeworkMenuIcon from '@/assets/images/icon_menu_homework@2x.png'
import homeworkMenuIconActive from '@/assets/images/icon_menu_homework_active@2x.png'

const Layout = () => import('../views/Layout.vue')
const baseData = () => import('../views/DataBoard/base.vue')
const moveData = () => import('../views/DataBoard/move.vue')

const homeworkAssignData = () => import('../views/DataBoard/homeworkAssign.vue')
const homeworkFinishData = () => import('../views/DataBoard/homeworkFinish.vue')

export const baseDataRoute: RouteConfig = {
  path: 'base',
  name: 'databoard_base',
  component: baseData,
  meta: {
    title: '基础数据',
    showMenu: true,
    roles: [Role.Offical],
  },
}

export const moveDataRoute: RouteConfig = {
  path: 'move',
  name: 'databoard_move',
  component: moveData,
  meta: {
    title: '运动数据',
    showMenu: true,
    roles: [Role.Offical],
  },
}

export const overviewRoute: RouteConfig = {
  path: '/organization/overview',
  name: 'organization_overview',
  component: Layout,
  meta: {
    title: '运动概览',
    icon: workbenchIcon,
    iconActive: workbenchIconActive,
    showMenu: true,
    roles: [Role.Offical],
  },
  children: [baseDataRoute, moveDataRoute],
}

export const homeworkAssignDataRoute: RouteConfig = {
  path: 'homework-assign',
  name: 'homework_assign',
  component: homeworkAssignData,
  meta: {
    title: '布置情况',
    showMenu: true,
    roles: [Role.Offical],
  },
}

export const homeworkFinishDataRoute: RouteConfig = {
  path: 'homework-finish',
  name: 'homework_finish',
  component: homeworkFinishData,
  meta: {
    title: '完成情况',
    showMenu: true,
    roles: [Role.Offical],
  },
}

export const homeworkRoute: RouteConfig = {
  path: '/organization/homework',
  name: 'organization_homework',
  component: Layout,
  meta: {
    title: '体育作业',
    icon: homeworkMenuIcon,
    iconActive: homeworkMenuIconActive,
    showMenu: true,
    roles: [Role.Offical],
  },
  children: [homeworkAssignDataRoute, homeworkFinishDataRoute],
}

export default [overviewRoute, homeworkRoute]
